import React, { useState, useEffect } from 'react';
import { Table, Card, Spin, Typography, Row, Col, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useConAppQry } from '../../api';
import { crawl } from '../../api/util';
import { knownIssuesColumns, tabPageCss } from './columns';
import styles from './KnownIssuesTracker.module.css';

const { Title, Text } = Typography;

const KnownIssuesTracker = ({ loader }) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);

    const inp = {
        type: 'fetch',
        qry: 'fetKitData',
    };

    const { data, isLoading, isError } = useConAppQry(inp, 'known_issues');

    // Process data when it loads
    useEffect(() => {
        if (data && Array.isArray(data)) {
            const processedData = data.map((item, index) => ({
                ...item,
                id: item.id || index,
            }));
            setOrigData(processedData);
            setFilteredData(processedData);

            // Create search index for crawl search
            const searchInd = processedData.map((item) => {
                const allValues = crawl(item);
                return { allValues: allValues.toString() };
            });
            setSearchIndex(searchInd);
        }
    }, [data]);

    // Handle search filtering
    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((item, index) => {
                if (item.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) {
                    return origData[index];
                }
                return null;
            });
            setFilteredData(
                reqData.filter((item) => {
                    if (item) return true;
                    return false;
                })
            );
        } else {
            setFilteredData(origData);
        }
    }, [searchVal, origData, searchIndex]);

    return (
        <div>
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={23}>
                    <Card
                        style={{ width: '100%', minHeight: '80vh' }}
                        title={
                            <div className={styles.cardHeader}>
                                <Title level={5} style={{ margin: 0 }}>
                                    Known Issues Tracker
                                </Title>
                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                    The data might subject to change based on ongoing investigations and resolutions.
                                </Text>
                            </div>
                        }
                        extra={
                            <Input
                                onChange={(e) => setSearchVal(e.target.value)}
                                prefix={<SearchOutlined className="site-form-item-icon" />}
                                placeholder="Crawl Search"
                                allowClear
                                style={{ width: '300px' }}
                            />
                        }
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        loading={isLoading}
                    >
                        {isLoading || loader ? (
                            <div className={styles.spinner}>
                                <Spin size="large" />
                            </div>
                        ) : isError ? (
                            <div style={{ textAlign: 'center', padding: '40px', color: 'red' }}>
                                <Text type="danger">Error loading known issues. Please try again.</Text>
                            </div>
                        ) : (
                            <Table
                                rowKey="id"
                                size="small"
                                bordered
                                scroll={{ x: 550, y: 900 }}
                                style={{ margin: '2px' }}
                                dataSource={filteredData}
                                columns={knownIssuesColumns(filteredData.length)}
                                loading={isLoading}
                                pagination={{
                                    pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                    defaultPageSize: 50,
                                    showSizeChanger: true,
                                    style: tabPageCss,
                                }}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default KnownIssuesTracker;
